const getSidebarOptions = state => state.common.sidebarOptions;

export default {
  getSidebarOptions,
};
